import lodash from 'lodash';
import { IAppointment } from 'src/interfaces/appointment';

/**
 * Will return if the lead has an active appointment
 *
 * @param {IAppointment[]} appointments
 * @return {boolean}
 */
export const hasAppointments = (appointments: IAppointment[]): boolean => {
    const lastAppointment = lodash.last<IAppointment>(appointments);

    if (!lastAppointment) return false;

    return lastAppointment.status;
};
